import { Col, Row } from 'antd';
import React from 'react';
import { formatPrice } from '../helpers';

interface Props {
  name?: string;
  totalAmount: number;
}

const PaymentDetailsFooterComponent: React.FC<Props> = ({ name, totalAmount }) => {
  return (
    <Row style={{ backgroundColor: '#ddd' }} justify='end'>
      <Col
        style={{ backgroundColor: '#333', color: 'white', padding: 10 }}
        xs={{ offset: 18, span: 6 }}
      >
        <strong>{name}</strong>
        <br />
        {formatPrice(totalAmount)}
      </Col>
    </Row>
  );
};

PaymentDetailsFooterComponent.defaultProps = {
  name: 'Vergoeding'
};

export { PaymentDetailsFooterComponent };
